/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Beweegactiviteitenreeks_Api_Errors_Invalid_BeoordelingsschaalInputs */

const nl_beweegactiviteitenreeks_api_errors_invalid_beoordelingsschaal = /** @type {(inputs: Beweegactiviteitenreeks_Api_Errors_Invalid_BeoordelingsschaalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`De beoordelingsschaal is ongeldig`)
};

/**

* @param {Beweegactiviteitenreeks_Api_Errors_Invalid_BeoordelingsschaalInputs} inputs
* @param {{ locale?: "nl" }} options
* @returns {LocalizedString}
*/
const beweegactiviteitenreeks_api_errors_invalid_beoordelingsschaal = /** @type {((inputs?: Beweegactiviteitenreeks_Api_Errors_Invalid_BeoordelingsschaalInputs, options?: { locale?: "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Beweegactiviteitenreeks_Api_Errors_Invalid_BeoordelingsschaalInputs, { locale?: "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return nl_beweegactiviteitenreeks_api_errors_invalid_beoordelingsschaal(inputs)
});
export { beweegactiviteitenreeks_api_errors_invalid_beoordelingsschaal as "beweegactiviteitenreeks.api_errors.invalid_beoordelingsschaal" }